export const coinAddress = "0x1de305515a132db0ed46e9fa2ad2804f066e43e3";
